import { createFileRoute } from '@tanstack/react-router'

import { AiDeclineCodesScreen } from './-components/ai-decline-codes-screen.tsx'

export const Route = createFileRoute('/payments/ai-decline-codes')({
  component: AiDeclineCodesScreen
})
